
<template>
  <div>
    <el-form
      ref="entityData"
      :model="entityData"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
      label-position="right"
    >
      <el-row :gutter="20">
        <!-- 论文题目 -->

        <el-col :span="12">
          <el-form-item
            prop="lunWenTiMu"
            label="论文题目"
          >
            <el-input
              v-model="entityData.lunWenTiMu"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 类别 -->

        <el-col :span="12">
          <el-form-item
            prop="leiBieDictKey"
            label="类别"
          >
            <Combox
              v-model="entityData.leiBieDictKey"
              type-id="D42"
              :option-data="getComboxData('D42')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 杂志 -->

        <el-col :span="12">
          <el-form-item
            prop="zaZhi"
            label="杂志"
          >
            <el-input
              v-model="entityData.zaZhi"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 发表年份 -->
        <el-col :span="12">
          <el-form-item
            prop="faBiaoNianFen"
            label="发表年份"
          >
            <el-date-picker
              v-model="entityData.faBiaoNianFen"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>

        <!-- 卷期页 -->

        <el-col :span="12">
          <el-form-item
            prop="juanQiYe"
            label="卷期页"
          >
            <el-input
              v-model="entityData.juanQiYe"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 收录类型 -->

        <el-col :span="12">
          <el-form-item
            prop="shouLuLeiXing"
            label="收录类型"
          >
            <el-input
              v-model="entityData.shouLuLeiXing"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 影响因子 -->

        <el-col :span="12">
          <el-form-item
            prop="yingXiangYinZi"
            label="影响因子"
          >
            <el-input
              v-model="entityData.yingXiangYinZi"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 备注 -->

        <el-col :span="12">
          <el-form-item
            prop="beiZhu"
            label="备注"
          >
            <el-input
              v-model="entityData.beiZhu"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 标题 -->

        <el-col :span="12">
          <el-form-item
            prop="biaoTi"
            label="标题"
          >
            <el-input
              v-model="entityData.biaoTi"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 摘要 -->

        <el-col :span="12">
          <el-form-item
            prop="zhaiYao"
            label="摘要"
          >
            <el-input
              v-model="entityData.zhaiYao"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 关键词 -->

        <el-col :span="12">
          <el-form-item
            prop="guanJianCi"
            label="关键词"
          >
            <el-input
              v-model="entityData.guanJianCi"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 语言 -->

        <el-col :span="12">
          <el-form-item
            prop="yuYanDictKey"
            label="语言"
          >
            <Combox
              v-model="entityData.yuYanDictKey"
              type-id="D43"
              :option-data="getComboxData('D43')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 期刊名称 -->

        <el-col :span="12">
          <el-form-item
            prop="qiKanMingCheng"
            label="期刊名称"
          >
            <el-input
              v-model="entityData.qiKanMingCheng"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- ISSN号 -->

        <el-col :span="12">
          <el-form-item
            prop="issnHao"
            label="ISSN号"
          >
            <el-input
              v-model="entityData.issnHao"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 状态 -->

        <el-col :span="12">
          <el-form-item
            prop="zhuangTaiDictKey"
            label="状态"
          >
            <Combox
              v-model="entityData.zhuangTaiDictKey"
              type-id="D44"
              :option-data="getComboxData('D44')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 日期 -->
        <el-col :span="12">
          <el-form-item
            prop="lunWenRiQi"
            label="日期"
          >
            <el-date-picker
              v-model="entityData.lunWenRiQi"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>

        <!-- 文章号 -->

        <el-col :span="12">
          <el-form-item
            prop="wenZhangHao"
            label="文章号"
          >
            <el-input
              v-model="entityData.wenZhangHao"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 收录情况 -->

        <el-col :span="12">
          <el-form-item
            prop="shouLuQingKuang"
            label="收录情况"
          >
            <el-input
              v-model="entityData.shouLuQingKuang"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 引用次数 -->

        <el-col :span="12">
          <el-form-item
            prop="yinYongCiShu"
            label="引用次数"
          >
            <el-input-number
              v-model="entityData.yinYongCiShu"
            />
          </el-form-item>
        </el-col>

        <!-- 基金标注 -->

        <el-col :span="12">
          <el-form-item
            prop="jiJinBiaoZhu"
            label="基金标注"
          >
            <el-input
              v-model="entityData.jiJinBiaoZhu"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 卷/期号 -->

        <el-col :span="12">
          <el-form-item
            prop="juanQiHao"
            label="卷/期号"
          >
            <el-input
              v-model="entityData.juanQiHao"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 起止页码 -->

        <el-col :span="12">
          <el-form-item
            prop="qiZhiYeMa"
            label="起止页码"
          >
            <el-input
              v-model="entityData.qiZhiYeMa"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- DOI -->

        <el-col :span="12">
          <el-form-item
            prop="doi"
            label="DOI"
          >
            <el-input
              v-model="entityData.doi"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 全文链接 -->

        <el-col :span="12">
          <el-form-item
            prop="quanWenLianJie"
            label="全文链接"
          >
            <el-input
              v-model="entityData.quanWenLianJie"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 助理 -->
        <el-col :span="12">
          <el-form-item
            prop="assitantList"
            label="助理"
          >
            <AssistEditForm
              v-model="entityData.assitantList"
              module-code="jx02"
            />
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <div class="dialog-footer">
      <el-button
        v-if="ketiInfo.isFuzeren || ketiInfo.isZuli"
        type="primary"
        @click="handleSave()"
      >
        保  存
      </el-button>
    </div>
  </div>
</template>
<script>
import pathReq from '@/api/pathlist'
import Combox from '@/views/managesystem/gz/com/Combox'
import AssistEditForm from '@/views/managesystem/gz/com/AssistEditForm.vue'
export default {
  components: {
    Combox, AssistEditForm
  },
  props: {
    // postId: { type: Number, default: null }
  },
  data() {
    return {
      entityId: null,
      entityData: {},
      allComboxData: [],
      rules: {
        lunWenTiMu: [
          { required: true, message: '请输入论文题目', trigger: 'change,blur' }
        ]
      },
      selectedValue: [],
      ketiInfo: {}
    }
  },
  computed: {},
  created() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D42;D43;D44').then(res => {
      this.allComboxData = res.data.result
    })
  },
  activated() {
    this.init()
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    /**
     * 初始化数据
     */
    init() {
      this.entityId = this.$route.params.id
      if (!this.entityId) {
        this.$router.go(-1)
        return
      }
      const path = '/api/services/app/ky03/GetEditky03?Id=' + this.entityId
      pathReq.getNoParams(path).then(res => {
        this.entityData = res.data.result.entityData
      }).then(_ => {
        pathReq.getKetiInfo('ky03', this.entityData.id).then(r => {
          this.ketiInfo = r.data.result
        })
      })
    },
    /**
     * 打开数据字典弹出框
     */
    handleAddComboxData(dictTypeId, dictTypeName) {
      this.$bus.emit('comboxData', dictTypeId, dictTypeName)
    },
    /**
     * 新增或者修改身份信息数据
     */
    handleSave() {
      this.$refs['entityData'].validate(valid => {
        if (valid) {
          const that = this
          const path = '/api/services/app/ky03/CreateOrUpdateky03'

          pathReq
            .postForm(path, { entityData: that.entityData })
            .then(res => {
              that.$message.success('保存成功')
            })
        }
      })
    }
  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 84% !important;
}
</style>
